import axios from 'axios';

const apiBase = process.env.REACT_APP_API_BASE
  ? `${process.env.REACT_APP_API_BASE.replace(/\/$/, '')}/api`
  : '/api';

const API = axios.create({ baseURL: apiBase });

API.interceptors.request.use(config => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default API;
